module.exports = __webpack_public_path__ + "img/0c50cfced9c27d6635e938827f780301.ttf";